import React from 'react';
import { Row, Col, Input } from 'reactstrap';
import { PhoneInput as InternationalPhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';

interface ContactInformationProps {
  contactInfoData: {
    firstName: string;
    lastName: string;
    isNameVisible: boolean;
    email: string;
    phone: string;
    contactPreference: string;
  };
}

const ContactInformation: React.FC<ContactInformationProps> = ({ contactInfoData }) => {

  // Helper function to display value or fallback
  const displayValue = (value: string | undefined | null) => {
    return value && value.trim() !== '' ? value : 'N/A';
  };

  return (
    <div className="mb-3">
      <Row className="mb-3">
        <Col md={6} className="mb-3 mb-md-0">
          <label className="form-label">First Name</label>
          <Input 
            type="text" 
            value={displayValue(contactInfoData?.firstName)} 
            readOnly 
          />
        </Col>
        <Col md={6}>
          <label className="form-label">Last Name</label>
          <Input 
            type="text" 
            value={displayValue(contactInfoData?.lastName)} 
            readOnly 
          />
        </Col>
      </Row>

      {contactInfoData?.isNameVisible && (
        <Row className="mb-3">
          <Col xs={12} className="d-flex align-items-center" style={{ fontSize: 18 }}>
            <i className="ri-check-line me-2" style={{ fontSize: 22 }}></i>
            <span>Hide My Name</span>
          </Col>
        </Row>
      )}

      <Row className="mb-3">
        <Col md={6} className="mb-3 mb-md-0">
          <label className="form-label">Email Address</label>
          <Input 
            type="email" 
            value={displayValue(contactInfoData?.email)} 
            readOnly 
          />
        </Col>
        <Col md={6}>
          <label className="form-label">Phone Number</label>
          {contactInfoData?.phone ? (
            <InternationalPhoneInput
              value={contactInfoData?.phone}
              onChange={() => {}}
              inputClassName="form-control"
              disabled
            />
          ) : (
            <Input 
              type="text" 
              value="N/A" 
              readOnly 
            />
          )}
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <label className="form-label">Contact Preference</label>
          <Input 
            type="text" 
            value={displayValue(contactInfoData?.contactPreference)} 
            readOnly 
          />
        </Col>
      </Row>
    </div>
  );
};

export default ContactInformation;